<!--
     Copyright (c) 2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<button type="button"
        class="btn btn-link"
        [title]="label | vtranslate"
        (click)="click($event)">
    <cds-icon *ngIf="mode === StringActionMode.CopyToClipboard"
              shape="copy-to-clipboard">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.PasteFromClipboard"
              shape="paste">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.DownloadFile"
              shape="download">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.UploadFile"
              shape="upload">
    </cds-icon>
</button>

<clr-signpost>
    <span clrSignpostTrigger></span>
    <ng-template [clrIfOpen]="error !== null"
                 (clrIfOpenChange)="errorSignpostChanged($event)">
        <clr-signpost-content [clrPosition]="'top-middle'">
            {{ error | vtranslate}}
        </clr-signpost-content>
    </ng-template>
</clr-signpost>

<clr-signpost>
    <span clrSignpostTrigger></span>

    <ng-template [clrIfOpen]="copied"
                 (clrIfOpenChange)="copiedSignpostChanged($event)">
        <clr-signpost-content [clrPosition]="'top-middle'">
            {{'copy.to.clipboard.copied' | vtranslate}}
        </clr-signpost-content>
    </ng-template>
</clr-signpost>

<input *ngIf="mode === StringActionMode.UploadFile"
       class="upload-file-input"
       #fileInput
       type="file"
       accept="text/plain"
       (change)="handleFile($event)">
